import { SortQueryDefaulted } from '@adflow/shared/util-data';

import type { ViewHistoryGMBTemplateDto } from './history-gmb-template.dto';

const HistoryGMBTemplateSortableFields: (keyof ViewHistoryGMBTemplateDto)[] = [
	'user',
	'createdAt',
	'action',
] as const;

export const DEFAULT_HISTORY_GMB_TEMPLATE_SORT = 'createdAt';
export const DEFAULT_HISTORY_GMB_TEMPLATE_SORT_DIR = 'desc';

export const ListHistoryGMBTemplateSort = SortQueryDefaulted(
	HistoryGMBTemplateSortableFields,
	DEFAULT_HISTORY_GMB_TEMPLATE_SORT,
	DEFAULT_HISTORY_GMB_TEMPLATE_SORT_DIR
);
